export default "<m-model\n  src=\"https://public.mml.io/duck.glb\"\n  rx=\"45\"\n  ry=\"-90\"\n  rz=\"45\"\n></m-model>\n";